import { i18n } from '@/lang'

export default () => {
  return i18n.t("message.AboutPage")
}



// WEBPACK FOOTER //
// ./src/data/config/about.js